/**
* @file 战队-战队建设
* @author 余凯
*/

import React from 'react'
import { Tabs, Progress, Button, Modal, Table, message } from 'antd'
import './index.less'
import { connect } from 'react-redux'

import Actions from '@/apis/team'

const { confirm } = Modal;

const columns = [
  {
    title: '建设时间',
    dataIndex: 'donate_time',
    // width: 150,
  },
  {
    title: '昵称',
    dataIndex: 'nickname',
    // width: 150,
  }
];

const BUILD_WEALTH = 50000

@connect(
  state => state.teamReducer,
)
class TeamBuild extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      own: 0,
      visible: false,
      data: {},
      rankList: [],
      buildList: []
    }
  }

  componentDidMount() {
    this.getData()
    this.getBuildRank()
  }

  showModal = async () => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game
    }
    const res = await Actions.getTeamDonateLog(params)
    if (res.code == 200) {
      this.setState({
        buildList: res.data,
        visible: true,
      })
    }
  };

  showConfirm = () => {
    const _this = this
    confirm({
      title: '建设确认通知',
      content: '您将花费' + BUILD_WEALTH + '金蛋建设战队，请确认！',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        const params = {
          id: _this.props.userInfo.game_team_id,
          game_id: _this.props.game,
          wealth: BUILD_WEALTH,
          add_xp: 5,
          add_prestige: 5
        }
        Actions.putBuildTeam(params).then(res => {
          if (res.code == 200) {
            message.success('建设成功')

            _this.getData()
            _this.getBuildRank()
          }
        })
      },
      onCancel() { },
    });
  }

  getData = async () => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game
    }
    const res = await Actions.getTeamDonateInfo(params)
    if (res.code == 200) {
      this.setState({
        data: res.data
      })
    }
  }

  getBuildRank = () => {
    const rankParams = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      type: 2,
      page_size: 10
    }
    Actions.getTeamRank(rankParams).then(res => {
      if (res.code == 200) {
        this.setState({
          rankList: res.data.list,
          myRank: res.data.rankNumber
        })
      }
    })
  }

  render() {
    const { data, buildList, rankList, myRank } = this.state
    return (
      <div className="team_build" id="team_build">
        <div className="user_wrap" >
          <div className="avatar">
            <img src={this.props.teamInfo.logo_image} />
          </div>
          <div className="user_info">
            <div className="info_item">
              <span className="label">我的排名：</span>
              <span className="content">{myRank}</span>
            </div>
            <div className="info_item">
              <span className="label">个人威望：</span>
              <span className="content">{data.prestige}</span>
            </div>
            <div className="info_item">
              <span className="label">战队经验：</span>
              <span className="content">{data.team_xp}</span>
            </div>
            <div className="info_btn">
              <div>
                <Button type="primary" onClick={this.showModal}>建设记录</Button>
              </div>
            </div>
          </div>
        </div>

        <div className="team_wrap">
          <div className="team_name">战队建设</div>
          <div className="tip_title">
            建设奖励
          </div>
          <div className="tip_item">
            个人威望

            +5（每次）
          </div>
          <div className="tip_item">
            战队经验

            +5（每次）
          </div>
          <Button type="primary" onClick={this.showConfirm}>
            建设战队
          </Button>
        </div>
        <div className="leaderboard">
          <div className="title">
            建设榜
          </div>
          <div className="table">
            <table>
              <thead>
                <tr>
                  <th width="15%">名次</th>
                  <th>用户昵称</th>
                  <th width="30%">建设次数</th>
                </tr>
              </thead>
              <tbody>
                {rankList.map((v, i) => (
                  <tr key={v.user_id} className={`${i < 3 ? 'green' : ''}`}>
                    <td className="table_id" ><span className={`table_index top_${i + 1}`}>{i + 1}</span></td>
                    <td className="table_name">{v.nickname}</td>
                    <td className="table_count"><span>{v.donate_wealth_times}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <Modal
          className="home_reward_wrap"
          title="建设记录"
          visible={this.state.visible}
          footer={null}
          getcontainer={false}
          // onOk={this.handleOk}
          onCancel={() => this.setState({
            visible: false
          })}
        >
          <Table
            // bordered
            // title={() => '我的名次'}
            size="small"
            columns={columns}
            dataSource={buildList}
            pagination={false}
            scroll={{ y: 240 }} />
        </Modal>
      </div>
    );
  }
}

export default TeamBuild;
